import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { Box, Paper } from '@mui/material';

import {
  DisputeReason,
  DisputeReasonDisplayMap,
} from '../../../../../common/constants/disputeReasons';
import { Reason, ReasonsEnum } from '../../../../../common/constants/reasons';
import { Resource } from '../../../../../common/constants/resource';
import { Dispute } from '../../../../tasks/types/dispute';
import { ReasonsChoicePanel } from '../../ReasonsChoicePanel';
import { RequiredFieldErrorBar } from '../../RequiredFieldErrorBar';
import { RequiredFieldTitle } from '../../RequiredFieldTitle';

const DISPUTE_REASON_OPTIONS: Reason[] = Object.values(DisputeReason).map(
  r => ({
    key: r as unknown as ReasonsEnum,
    displayName: DisputeReasonDisplayMap[r],
  }),
);

export const DisputeLayout = ({
  dispute,
  setDispute,
  isExpanded,
  disputeError,
}: {
  dispute: Dispute;
  setDispute: Dispatch<SetStateAction<Dispute>>;
  isExpanded: boolean;
  disputeError: boolean;
}) => {
  const [selectedReasons, setSelectedReasons] = useState(
    dispute.reason || ([] as string[]),
  );

  useEffect(() => {
    if (!isExpanded) {
      setSelectedReasons([] as string[]);
      setDispute({} as Dispute);
    }
  }, [isExpanded, setDispute]);

  useEffect(() => {
    if (isExpanded) {
      setDispute({ reason: selectedReasons } as Dispute);
    }
  }, [isExpanded, selectedReasons, setDispute]);

  return (
    <Box>
      {disputeError && (
        <Box mb={1}>
          <RequiredFieldErrorBar />
        </Box>
      )}
      <Box mt={3}>
        <Paper
          elevation={0}
          style={{ backgroundColor: 'var(--neutrals-night-10)' }}
        >
          <Box p={1.5} pt={1.5}>
            <RequiredFieldTitle title={Resource.ORDER_REASON} />
            <ReasonsChoicePanel
              reasons={DISPUTE_REASON_OPTIONS}
              selectedReasons={selectedReasons}
              selectReasonsCallback={setSelectedReasons}
            />
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};
